import { render, staticRenderFns } from "./SewipTherapists.vue?vue&type=template&id=60cd9044&scoped=true&lang=pug&"
import script from "./SewipTherapists.vue?vue&type=script&lang=ts&"
export * from "./SewipTherapists.vue?vue&type=script&lang=ts&"
import style0 from "./SewipTherapists.vue?vue&type=style&index=0&id=60cd9044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cd9044",
  null
  
)

export default component.exports